/* eslint-disable */
import { createContext, useContext, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'

const WorryingContext = createContext(null)

export const WorryingProvider = ({ children }) => {
  const [state, setState] = useState({
    visible: false,
    title: '',
    message: '',
  })

  const showWorrying = ({ title, message }) => {
    setState({
      visible: true,
      title,
      message,
    })
  }

  const onClose = () => {
    setState((prev) => ({ ...prev, visible: false }))
  }

  return (
    <WorryingContext.Provider value={{ showWorrying }}>
      {children}

      <CModal size="sm" visible={state.visible} onClose={onClose} backdrop="static">
        <CModalHeader>
          <CModalTitle>{state.title}</CModalTitle>
        </CModalHeader>

        <CModalBody>{state.message}</CModalBody>

        <CModalFooter>
          <CButton color="dark" className="text-white" onClick={onClose}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </WorryingContext.Provider>
  )
}

export const useWorrying = () => {
  const context = useContext(WorryingContext)
  if (!context) {
    throw new Error('useWorrying must be used within a WorryingProvider')
  }
  return context
}
